import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { HighTradingVolumeBrokersViewModel } from './high-trading-volume-brokers.model';

export class HighTradingVolumeBrokersConfiguration extends ReportSectionConfigurationBase {
  typeName = 'HighTradingVolumeBrokersConfiguration';
  nodataLocalizationKeyName = 'bnyHighTradingVolumeBrokers';
  readonly reportSection = ReportSection.HighTradingVolumeBrokers;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_HighTradingVolumeBrokers];
  minSize = 2;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'drsIssued',
      displayName: 'DRs Issued',
      isSelected: true,
      canConfigure: true,
      subSections: [
        {
          name: 'drsIssuedBroker',
          displayName: 'Broker',
          isSelected: true,
          canConfigure: true,
          isStatic: true
        },
        {
          name: 'drsIssuedSubsection',
          displayName: 'DRs Issued',
          isSelected: true,
          canConfigure: true,
          isStatic: true
        },
        {
          name: 'issuedTransactions',
          displayName: '# Trans',
          isSelected: true,
          canConfigure: true,
          property: 'trans'
        }
      ]
    },
    {
      name: 'drsCancelled',
      displayName: 'Cancelled',
      isSelected: true,
      canConfigure: true,
      subSections: [
        {
          name: 'drsCancelledBroker',
          displayName: 'Broker',
          isSelected: true,
          canConfigure: true,
          isStatic: true
        },
        {
          name: 'drsCancelledSubsection',
          displayName: 'DRs Cancelled',
          isSelected: true,
          canConfigure: true,
          isStatic: true
        },
        {
          name: 'cancelledTransactions',
          displayName: '# Trans',
          isSelected: true,
          canConfigure: true,
          property: 'trans'
        }
      ]
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'highTradingVolumeBrokers';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'Brokers With Highest Cross-Border Trading Volume';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface HighTradingVolumeBrokersData {
  [ReportViewModelSection.BnyManagementReport_HighTradingVolumeBrokers]: HighTradingVolumeBrokersViewModel;
}
